module.exports = __webpack_public_path__ + "static/img/level1.9fe93644.png";